const tasks = {
  addSubtask: 'Add a subtask',
  addTimeEntry: 'Add a time entry',
  editTimeEntry: 'Edit a time entry',
  allTasks: 'All Tasks',
  archivedTasks: 'Archived Tasks',
  cancelledTasks: 'Cancelled Tasks',
  completeTasks: 'Complete Tasks',
  createASection: 'Create a Section',
  createATask: 'Create a Task',
  estimatedCompletionTime: 'Estimated Completion Time',
  incompleteTasks: 'Incomplete Tasks',
  noTasksToDisplay: 'No tasks to display',
  noTimeEntries: 'No time entries',
  parentTask: 'Parent task',
  subtasks: 'Subtasks',
  task: 'Task',
  taskCreated: 'Created the task',
  taskDeleted: 'Deleted the task',
  taskHistoryAssigneeCleared: 'Assignee cleared',
  taskHistoryAssigneeSet: 'Assignee set to {{assignee}}',
  taskHistoryDueDateCleared: 'Due date cleared',
  taskHistoryImportanceCleared: 'Importance cleared',
  taskHistoryImportanceSet: 'Importance set to {{importance}}',
  taskHistoryDueDateSet: 'Due date set to {{date}}',
  taskHistoryStartDateCleared: 'Start date cleared',
  taskHistoryStartDateSet: 'Start date set to {{date}}',
  taskHistoryProjectsAssigned_one: 'Assigned to {{projects}}',
  taskHistoryProjectsAssigned_other: 'Assigned to {{projects}}',
  taskHistoryProjectsUnassigned_one: 'Unassigned from {{projects}}',
  taskHistoryProjectsUnassigned_other: 'Unassigned from {{projects}}',
  taskHistoryTimeLeftCleared: 'Time left cleared',
  taskHistoryTimeLeftSet: 'Time left set to {{hours}}',
  taskHistoryTimeLogged: '{{user}} logged {{hours}} on {{date}}',
  taskHistoryTimeLoggedRange: '{{user}} logged {{hours}} from {{start}} to {{end}}',
  taskHistoryTimeRemoved: '{{user}} removed {{hours}} logged on {{date}}',
  taskHistoryTimeRemovedRange: '{{user}} removed {{hours}} logged from {{start}} to {{end}}',
  tasks: 'Tasks',
  tasksDueForThisWeek: 'Tasks Due for this Week',
  tasksDueForToday: 'Tasks Due for Today',
  taskUpdated: 'Updated the task',
  taskUpdatedFields: 'Updated {{fields}}',
  timeLogged: 'Time logged',
  xSelectedTasks_one: '{{count}} selected task',
  xSelectedTasks_other: '{{count}} selected tasks',
  youHaveNoOverdueTasks: 'You have no overdue tasks.',
  youHaveTooMuchToDo: 'You have an average of {{avgHours}} hours per day to complete before {{date}}.',
  youHaveTooMuchToDoNext7Days: 'You have an average of {{avgHours}} hours per day to complete in the next 7 days.',
  youHaveTooMuchToDoToday: 'You have {{avgHours}} hours to complete before the end of the day.',
  youHaveXOverdueTasks_one: 'You have {{count}} overdue task.',
  youHaveXOverdueTasks_other: 'You have {{count}} overdue tasks.',
  youHaveXTasksWithNoDueDate_one: 'You have {{count}} task with no due date.',
  youHaveXTasksWithNoDueDate_other: 'You have {{count}} tasks with no due date.',
};

export default tasks;
